import { OrderStatusEnum } from '@/enums'
import { Badge } from '@/components/ui/badge'
import { useTranslations } from 'next-intl'

type PropsType = {
  status: OrderStatusEnum
}

const statusVariantMap: Record<
  OrderStatusEnum,
  'default' | 'secondary' | 'outline' | 'success' | 'destructive' | 'warning'
> = {
  [OrderStatusEnum.PENDING]: 'warning',
  [OrderStatusEnum.CONFIRMED]: 'secondary',
  [OrderStatusEnum.PROCESSING]: 'default',
  [OrderStatusEnum.SHIPPED]: 'default',
  [OrderStatusEnum.DELIVERED]: 'success',
  [OrderStatusEnum.CANCELLED]: 'destructive',
  [OrderStatusEnum.REFUNDED]: 'outline'
}

const OrderStatusBadge = ({ status }: PropsType) => {
  const t = useTranslations()
  return <Badge variant={statusVariantMap[status] ?? 'secondary'}>{t(`order_status_${status}` as any)}</Badge>
}

export default OrderStatusBadge
